var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInventory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.249 11.8295L2.99902 8.3595V16.0895C3.00337 16.4118 3.09983 16.7262 3.27701 16.9956C3.4542 17.2649 3.70472 17.4779 3.99902 17.6095L11.189 20.9995H11.249V11.8295Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0012 10.4999L20.5112 6.92988C20.368 6.77076 20.1947 6.64161 20.0012 6.54989L12.8012 3.17989C12.5511 3.06152 12.2779 3.00012 12.0012 3.00012C11.7245 3.00012 11.4513 3.06152 11.2012 3.17989L4.00121 6.54989C3.80777 6.64161 3.63443 6.77076 3.49121 6.92988L12.0012 10.4999Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.749 11.8295V20.9995H12.799L19.999 17.6095C20.2918 17.4786 20.5413 17.2671 20.7184 16.9998C20.8954 16.7324 20.9928 16.4201 20.999 16.0995V8.3595L12.749 11.8295Z",
    fill: "#808080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInventory);
export default __webpack_public_path__ + "static/media/icon-inventory.050910bb828a84880e12efcb4e9b055a.svg";
export { ForwardRef as ReactComponent };